export { PRIMARY_PATHS, ESSENTIAL_GUIDES } from './siteNavigation';

export {
	HOME_SEARCH_SUGGESTIONS,
	HOME_SEARCH_CHIPS,
	HOME_SEARCH_INDEX,
	searchHomeIndex,
	findHomeSearchMatch,
} from './homeSearchIndex';

export const HOME_FEATURED_JOURNEYS = [
	{
		slug: 'everest-base-camp',
		title: 'Everest Base Camp',
		subtitle: 'Gold-standard guided journey — 95% coverage, Lukla to 5,364m.',
		duration: '12–14 days',
		difficulty: 'Strenuous',
		coverage: 95,
		badge: 'Benchmark',
		isBenchmark: true,
		route: '/journeys/everest-base-camp',
		imageKey: 'heroEverest',
	},
	{
		slug: 'annapurna-base-camp',
		title: 'Annapurna Base Camp',
		subtitle: 'Best first high-altitude trek — forest to glacier amphitheatre.',
		duration: '7–10 days',
		difficulty: 'Moderate–hard',
		coverage: 75,
		badge: 'Live now',
		route: '/journeys/annapurna-base-camp',
		imageKey: 'annapurnaAbc',
	},
	{
		slug: 'langtang-valley',
		title: 'Langtang Valley',
		subtitle: 'Closest Himalaya to Kathmandu — Tamang culture, no mountain flight.',
		duration: '7–9 days',
		difficulty: 'Moderate',
		coverage: 72,
		badge: 'Live now',
		route: '/journeys/langtang-valley',
		imageKey: 'heroEverest',
	},
];

export const HOME_FEATURED_DESTINATIONS = [
	{ name: 'Phewa Lake', route: '/destinations/phewa-lake', tag: 'Pokhara', imageKey: 'peacePagoda' },
	{ name: 'Chitwan', route: '/destinations/chitwan-national-park', tag: 'Wildlife', illustration: 'wildlife' },
	{ name: 'Bhaktapur', route: '/destinations/bhaktapur-durbar-square', tag: 'Heritage', imageKey: 'peacePagoda' },
	{ name: 'Annapurna', route: '/destinations/annapurna-base-camp', tag: 'Trekking', imageKey: 'annapurnaAbc' },
	{ name: 'Lumbini', route: '/destinations/lumbini', tag: 'Spiritual', illustration: 'festival' },
];

export const HOME_FEATURED_JOURNEY = {
	title: 'Everest Base Camp',
	subtitle: 'Our deepest guided journey — permits, timeline, budget, and AMS decisions in one place.',
	duration: '12–14 days',
	difficulty: 'Strenuous',
	route: '/journeys/everest-base-camp',
	imageKey: 'heroEverest',
};

export const HOME_FEATURED_FESTIVALS = [
	{ slug: 'dashain', month: 'Sep–Oct', name: 'Dashain', summary: "Nepal's longest and most important festival." },
	{ slug: 'tihar', month: 'Oct–Nov', name: 'Tihar', summary: 'Festival of lights — honors animals and family bonds.' },
	{ slug: 'holi', month: 'March', name: 'Holi', summary: 'Festival of colors — visitors are welcome to join in.' },
	{ slug: 'buddha-jayanti', month: 'May', name: 'Buddha Jayanti', summary: 'Celebration at Lumbini and Boudhanath.' },
	{ slug: 'indra-jatra', month: 'September', name: 'Indra Jatra', summary: 'Kathmandu Valley chariots, dancers, and Kumari.' },
	{ slug: 'bisket-jatra', month: 'April', name: 'Bisket Jatra', summary: "Bhaktapur's spectacular New Year chariot festival." },
];
